import { styled } from 'styled-components'
import COLORS from '@web-ui-kit/colors'
import SHADOWS from '@web-ui-kit/shadows'
import SPACES from '@web-ui-kit/spaces'
import Sidebar from 'components/Sidebar'

export const HoverLogoContainer = styled.div`
  display: flex;
  gap: ${SPACES.S};
  opacity: 0;
  position: absolute;
  top: 0;
  transition: opacity 0.3s;
  & > svg:last-child {
    height: 2.1875rem;
    width: 6.9375rem;
  }
`
export const LogoContainer = styled.div`
  position: relative;
`

export const CustomSidebar = styled(Sidebar)`
  border-right: 0.0625rem solid ${COLORS.NEUTRAL_300};
  grid-area: nav;
  overflow: hidden;
  top: 0;
  transition: 0.3s;
  white-space: nowrap;
  width: 3.5rem;
  &:hover {
    box-shadow: ${SHADOWS.NAV_RAIL_SHADOW};
    width: 15.375rem;
    & ${HoverLogoContainer} {
      opacity: 1;
    }
  }
  & > nav {
    padding: 0 ${SPACES.XS};
    & > ul {
      min-width: 2.5rem;
      & > li {
        overflow: hidden;
        & > button {
          gap: ${SPACES.S};
          padding: ${SPACES['2XS']};
          & > svg {
            min-height: 2rem;
            min-width: 2rem;
          }
        }
      }
    }
  }
`
